const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: 'block',
    minWidth: minWidth / 2
  },
  select: {
    width: '150px'
  },
  block: {
    display: 'block'
  },
  modal: {
    maxWidth: minWidth / 1.5
  },
  modalHeader: {
    fontWeight: '600!important',
    fontSize: '1.2rem!important',
  },
  logo: {
    height: '50px',
    maxHeight: '50px',
    backgroundColor: 'grey',
    border: '1px solid white',
    display: 'inline-block'
  },
  LogoMissing: {
    width: '50px',
    height: '50px',
    maxHeight: '50px',
    maxWidth: '50px',
    backgroundColor: 'grey',
    border: '1px solid white',
    display: 'inline-block'
  },
  logoButton: {
    width: '20px',
    height: '20px',
    minHeight: '20px',
    position: 'relative',
    top: '-40px',
    left: '-10px'
  },
  logoButtonAdd: {
    backgroundColor: theme.palette.accent,
    color: 'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  logoButtonRemove: {
    backgroundColor: theme.palette.accent,
    color: 'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  logoButtonIcon: {
    fontSize: '8pt'
  },
  form: {
    maxHeight: minHeight / 2,
    overflowY: 'scroll'
  },
  button: {
    marginLeft: theme.spacing.unit * 2
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: 'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  close: {
    padding: 0,
    minWidth: 40,
  },
  error: {
    background: theme.palette.secondary.main,
    color: theme.palette.common.white,
    textAlign: 'center'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/custorg/new/styles.js